<template>
  <div>
    <!-- Sticky Top Bar with Breadcrumb -->
    <TopBar
      parentTitle="Units"
      :currentTitle="unit.term || 'New Unit'"
      :backRoute="{ name: 'IngredientUnitListView' }"
    >
      <b-button outlined type="is-primary" size="is-small" icon-left="check" @click="saveAndClose">Save & Close</b-button>
      <b-button type="is-primary" size="is-small" icon-left="content-save" @click="save">Save</b-button>
    </TopBar>

    <div class="page-content">
      <!-- Page Header -->
      <div class="page-header">
        <div class="page-title-group">
          <h1 class="page-title">{{ unit.term || 'New Unit' }}</h1>
          <p class="page-subtitle">Ingredient Unit Editor</p>
        </div>
      </div>

      <!-- Form Card -->
      <FeedsCard title="Unit Details">
        <div class="form-group">
          <label class="form-label">Unit Term</label>
          <b-input
            v-model="unit.term"
            placeholder="e.g. pinch"
            @input="saveDebounced" />
        </div>
        <div class="form-group">
          <label class="form-label">Plural</label>
          <b-input
            v-model="unit.plural"
            placeholder="e.g. pinches"
            @input="saveDebounced" />
          <p class="form-hint">Leave blank if no plural is needed</p>
        </div>
      </FeedsCard>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import db from "@/firebase/db"
import FeedsCard from "@/components/common/FeedsCard"
import TopBar from "@/components/layout/TopBar"

export default {
  name: 'IngredientUnitView',
  components: {
    FeedsCard,
    TopBar
  },
  props: [
    'id'
  ],
  data() {
    return {
      unit: {},
    };
  },
  created: function () {
    db.collection('ingredient_units')
      .doc(this.id)
      .get()
      .then(snapshot => {
        this.unit = snapshot.data()
      })
  },
  methods: {
    saveDebounced: debounce(function () {
      this.save()
    }, 1000),
    async saveAndClose(){
      this.save()
        .then(() => {
          this.$router.go(-1)
        })
    },
    async save(){
      db.collection('ingredient_units')
        .doc(this.id)
        .set(this.unit)
        .then(() => {
          this.$buefy.toast.open({type: 'is-success', message: `Ingredient unit successfully updated!`})
        })
        .catch((error) => {
          this.$buefy.toast.open({type: 'is-danger', message: `Error saving ingredient unit: ${error}`})
        });
    },
  }
}
</script>
